import { NotificationAlert } from '@cellula/react';
import { VonageEncryptionWarningDialog } from './_vonage_encryption_warning_dialog.component';
import { VonageEncryptionWarningText } from './_vonage_encryption_warning_text.component';
import { VonageEncryptionWarningTitle } from './_vonage_encryption_warning_title.component';
import { useVonageEncryptionWarning } from './use_vonage_excryption_warning.hook';

export const PrimitiveVonageEncryptionWarning = {
	Title: VonageEncryptionWarningTitle,
	Text: VonageEncryptionWarningText,
	Dialog: VonageEncryptionWarningDialog,
};

export function VonageEncryptionWarning() {
	const { hasEncryptionSupport } = useVonageEncryptionWarning();

	if (hasEncryptionSupport) {
		return null;
	}

	return (
		<>
			<NotificationAlert variant='danger'>
				<PrimitiveVonageEncryptionWarning.Text type='notificationAlert' />
			</NotificationAlert>
			<PrimitiveVonageEncryptionWarning.Dialog />
		</>
	);
}
